/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const DECIMAL_TYPE = {
  FLOAT: 'FLOAT',
  ROUND: 'ROUND',
  FLOOR: 'FLOOR',
  CEIL: 'CEIL',
} as const;

export const PRICE_PREFIX = {
  ADD: '+',
  SUBTRACT: '-',
  MULTIPLY: 'x',
  DIVIDE: '/',
  FROM: 'From',
} as const;

export const CURR_DISPLAY = {
  SYMBOL: 'symbol',
  CODE: 'code',
  NARROW_SYMBOL: 'narrowSymbol',
  NAME: 'name',
} as const;

export type DecimalType = (typeof DECIMAL_TYPE)[keyof typeof DECIMAL_TYPE];
export type PricePrefix = (typeof PRICE_PREFIX)[keyof typeof PRICE_PREFIX];
export type CurrencyDisplay = (typeof CURR_DISPLAY)[keyof typeof CURR_DISPLAY];

export const ARR_DECIMAL_TYPE = Object.keys(DECIMAL_TYPE) as Array<
  keyof typeof DECIMAL_TYPE
>;
export const ARR_PRICE_PREFIX = Object.keys(PRICE_PREFIX) as Array<
  keyof typeof PRICE_PREFIX
>;
export const DEFAULT_LOCALE = 'en-gb';
export const BUNDLE_DECIMAL_PLACES = 2;
export const REWARDS_CURRENCY = ['PTS', 'LPX'];
